export function joinMessage(partyId, key, party, liteSessionId) {
  return {
    method: 'con:join',
    params: {
      liteSessionId,
      key,
      party,
      partyId,
    },
  }
}

export function disjoinMessage() {
  return {
    method: 'con:disjoin',
  }
}

export function readyMessage(id, sdp) {
  return {
    method: 'con:ready',
    params: {},
  }
}
